module.exports = __webpack_public_path__ + "static/domain-driven-design-35b71881fa8857d12a07f032c736a89e.jpeg";